import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ScaleFlowLogo = ({ className = "w-10 h-10", showText = true }) => {
  const { isDark } = useTheme();
  
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Icon - only show when sidebar is extended */}
      {showText && (
        <div className="flex-shrink-0">
          <img 
            src={isDark ? "/images/Logo-dark.png" : "/images/Logo-light.png"} 
            alt="ScaleFlow Logo"
            className="w-40 h-40 object-contain"
          />
        </div>
      )}
      
    </div>
  );
};

export default ScaleFlowLogo; 